import React from "react";
import Header from "../../components/Header";
import TextField from "../../components/TextField";
import Checkbox from "../../components/Checkbox";
import {
  COMPONENT_ERROR_TEXT,
  FIELD_ERROR_TEXT,
  PROVINCES_LIST,
  subformInputChange,
} from "../../utils";
import { IconButton } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import DeleteIcon from "@mui/icons-material/Delete";
import { Card, Flex } from "antd";
import TextArea from "../../components/TextArea";
import DateField from "../../components/DateField";
import Dropdown from "../../components/Dropdown";

const ErrorOmission = ({
  data,
  setData,
  error,
  setError,
  handleInputChange,
  disabled,
  btnLoading,
}) => {
  return (
    <div>
      <Header text="Insurance Coverages" />

      <div className="form_container">
        <p className="secondary_title">Errors & Omissions Coverage</p>
        <TextField
          label="Insurer"
          name="eo_insurer"
          value={data?.eo_insurer}
          handleChange={handleInputChange}
          error_state={error?.eo_insurer}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
        <TextField
          label="Policy #"
          name="eo_policy"
          value={data?.eo_policy}
          handleChange={handleInputChange}
          error_state={error?.eo_policy}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
        <TextField
          label="Limit"
          name="eo_limit"
          value={data?.eo_limit}
          handleChange={handleInputChange}
          error_state={error?.eo_limit}
          error_text={FIELD_ERROR_TEXT}
          required
          custom="number"
          disabled={disabled?.stage || btnLoading}
        />
        <DateField
          label="Expiry Date"
          name="eo_expiry_date"
          value={data?.eo_expiry_date}
          handleChange={(date, dateString) => {
            if (date) {
              setData({ ...data, eo_expiry_date: date });

              setError({ ...error, eo_expiry_date: false });
            } else {
              setData({ ...data, eo_expiry_date: "" });

              setError({ ...error, eo_expiry_date: true });
            }
          }}
          error_state={error?.eo_expiry_date}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
        <Checkbox
          label="Has there been any E&O claims in the past 5 years?"
          firstoption="Yes"
          secondoption="No"
          required
          name="has_eando_claims_in_last_5years"
          value={data?.has_eando_claims_in_last_5years}
          handleChangeFirst={(e) => {
            let { name, value } = e.target;
            value.trim();

            if (value === "Yes") {
              setError({ ...error, [name]: false, eando_claim_details: true });
            }

            setData({ ...data, [name]: value, eando_claim_details: "" });
          }}
          handleChangeSecond={(e) => {
            let { name, value } = e.target;
            value.trim();

            if (value === "No") {
              setError({ ...error, [name]: false, eando_claim_details: false });
            }

            setData({ ...data, [name]: value, eando_claim_details: "" });
          }}
          error_state={error?.has_eando_claims_in_last_5years}
          error_text={FIELD_ERROR_TEXT}
          disabled={disabled?.stage || btnLoading}
        />

        {data?.has_eando_claims_in_last_5years === "Yes" ? (
          <TextArea
            label="E&O Claims Details"
            required
            name="eando_claim_details"
            value={data?.eando_claim_details}
            handleChange={handleInputChange}
            error_state={error?.eando_claim_details}
            error_text={FIELD_ERROR_TEXT}
            disabled={disabled?.stage || btnLoading}
          />
        ) : (
          ""
        )}

        <p className="secondary_title">Cyber Coverage</p>
        <TextField
          label="Insurer"
          name="cyber_insurer"
          value={data?.cyber_insurer}
          handleChange={handleInputChange}
          error_state={error?.cyber_insurer}
          error_text={FIELD_ERROR_TEXT}
          required
          disabled={disabled?.stage || btnLoading}
        />
        <TextField
          label="Limit"
          name="cyber_limit"
          value={data?.cyber_limit}
          handleChange={handleInputChange}
          error_state={error?.cyber_limit}
          error_text={FIELD_ERROR_TEXT}
          required
          custom="number"
          disabled={disabled?.stage || btnLoading}
        />

        <div className="mb_16"></div>

        <Flex gap={32} align="center" className="mb_16">
          <p className="label">Licensing</p>
          <button
            className="next_btn subform_add_btn"
            onClick={() => {
              let undefined_check_error = error.licensing.some((item) => {
                return Object.values(item).some((value) => value === undefined);
              });

              if (undefined_check_error) {
                let copy_error = { ...error };

                copy_error.licensing.map((item) => {
                  for (const key in item) {
                    if (item[key] === undefined) {
                      item[key] = true;
                    }
                  }
                });

                setError(copy_error);
                return;
              }

              let true_check_error = error.licensing.some((item) => {
                return Object.values(item).some((value) => value === true);
              });

              if (true_check_error) {
                return;
              }

              let key = uuidv4();

              setData({
                ...data,
                licensing: [
                  ...data?.licensing,
                  { key, province: "", license: "", expiry_date: "" },
                ],
              });

              setError({
                ...error,
                licensing: [
                  ...error?.licensing,
                  {
                    key,
                    province: undefined,
                    license: undefined,
                    expiry_date: undefined,
                  },
                ],
              });
            }}
            disabled={disabled?.stage || btnLoading}
          >
            Add licensing
          </button>
        </Flex>

        <Flex vertical gap={32}>
          {data?.licensing.map((item, index) => {
            return (
              <Card
                title={
                  <p>
                    Licensing #{index + 1}{" "}
                    {Object.values(error.licensing[index]).some(
                      (value) => value === true
                    ) ? (
                      <span className="subform_error_text">
                        {COMPONENT_ERROR_TEXT}
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                }
                size="small"
                key={index}
                extra={
                  <IconButton
                    onClick={() => {
                      let filter = data?.licensing.filter(
                        (i) => item?.key !== i?.key
                      );

                      let error_filter = error?.licensing.filter(
                        (i) => item?.key !== i?.key
                      );

                      if (filter.length === 0) {
                        return;
                      }

                      setError({ ...error, licensing: error_filter });

                      setData({ ...data, licensing: filter });
                    }}
                    disabled={
                      data?.licensing.length === 1 ||
                      disabled?.stage ||
                      btnLoading
                    }
                  >
                    <DeleteIcon
                      style={{ fontSize: "1.25rem", color: "#fb7d7f" }}
                    />
                  </IconButton>
                }
              >
                <div className="form_container" style={{ padding: "0" }}>
                  <Dropdown
                    size="middle"
                    label="Province"
                    options={PROVINCES_LIST}
                    handleChange={(value) =>
                      subformInputChange({
                        value: value,
                        name: "province",
                        object_key: "licensing",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="province"
                    value={item?.province}
                    required
                    error_state={error?.licensing[index]?.province}
                    disabled={disabled?.stage || btnLoading}
                  />
                  {/* <TextField
                    size="middle"
                    label="Province"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "licensing",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="province"
                    value={item?.province}
                    required
                    error_state={error?.licensing[index]?.province}
                  />{" "} */}
                  <TextField
                    size="middle"
                    label="License #"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "licensing",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="license"
                    value={item?.license}
                    required
                    error_state={error?.licensing[index]?.license}
                    disabled={disabled?.stage || btnLoading}
                  />
                  <DateField
                    label="Expiry Date"
                    name="expiry_date"
                    value={item?.expiry_date}
                    handleChange={(date, dateString) =>
                      subformInputChange({
                        value: date,
                        name: "expiry_date",
                        object_key: "licensing",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                        custom: "date",
                      })
                    }
                    required
                    size="middle"
                    error_state={error?.licensing[index]?.expiry_date}
                    disabled={disabled?.stage || btnLoading}
                  />
                </div>
              </Card>
            );
          })}
        </Flex>

        <div className="mb_16"></div>

        <Checkbox
          label="Has the Brokerage had any license(s) suspended, terminated or been fined?"
          firstoption="Yes"
          secondoption="No"
          required
          name="any_licensce_suspended"
          value={data?.any_licensce_suspended}
          handleChangeFirst={(e) => {
            let { name, value } = e.target;
            value.trim();

            if (value === "Yes") {
              setError({ ...error, [name]: false, suspended_details: true });
            }

            setData({ ...data, [name]: value, suspended_details: "" });
          }}
          handleChangeSecond={(e) => {
            let { name, value } = e.target;
            value.trim();

            if (value === "No") {
              setError({ ...error, [name]: false, suspended_details: false });
            }

            setData({ ...data, [name]: value, suspended_details: "" });
          }}
          error_state={error?.any_licensce_suspended}
          error_text={FIELD_ERROR_TEXT}
          disabled={disabled?.stage || btnLoading}
        />

        {data?.any_licensce_suspended === "Yes" ? (
          <TextArea
            label="Suspended Licence Details - List each issues and explain"
            required
            name="suspended_details"
            value={data?.suspended_details}
            handleChange={handleInputChange}
            error_state={error?.suspended_details}
            error_text={FIELD_ERROR_TEXT}
            disabled={disabled?.stage || btnLoading}
          />
        ) : (
          ""
        )}

        <Checkbox
          label="Has the Brokerage or any licensed individual representing the Brokerage been reprimanded by a Regulator in the past 5 years?"
          firstoption="Yes"
          secondoption="No"
          required
          name="brokerage_reprimanded_in_5years"
          value={data?.brokerage_reprimanded_in_5years}
          handleChangeFirst={(e) => {
            let { name, value } = e.target;
            value.trim();

            if (value === "Yes") {
              setError({ ...error, [name]: false, reprimand_details: true });
            }

            setData({ ...data, [name]: value, reprimand_details: "" });
          }}
          handleChangeSecond={(e) => {
            let { name, value } = e.target;
            value.trim();

            if (value === "No") {
              setError({ ...error, [name]: false, reprimand_details: false });
            }

            setData({ ...data, [name]: value, reprimand_details: "" });
          }}
          error_state={error?.brokerage_reprimanded_in_5years}
          error_text={FIELD_ERROR_TEXT}
          disabled={disabled?.stage || btnLoading}
        />

        {data?.brokerage_reprimanded_in_5years === "Yes" ? (
          <TextArea
            label="Reprimand Details - List each issues and explain"
            required
            name="reprimand_details"
            value={data?.reprimand_details}
            handleChange={handleInputChange}
            error_state={error?.reprimand_details}
            error_text={FIELD_ERROR_TEXT}
            disabled={disabled?.stage || btnLoading}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ErrorOmission;
